import { render, staticRenderFns } from "./deposit-settlement.vue?vue&type=template&id=4e2ef20e&"
import script from "./deposit-settlement.vue?vue&type=script&lang=js&"
export * from "./deposit-settlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports